module.exports = __webpack_public_path__ + "static/media/sprite.1682bbd9.svg";